import { BasicEnumerable } from "../BasicEnumerable.js";
export const skip = (source, count) => {
    function* iterator() {
        let i = 0;
        for (const item of source) {
            if (i++ >= count) {
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
